module.exports = __webpack_public_path__ + "static/media/gwen-stacy-lose.68a8bffb.png";